import {
  Component,
  OnInit,
  Input,
  HostListener,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BassScaResetPasswordService } from "./services/reset-password.service";
import { ErrorMessages } from "src/common-items/error-messages/error-messages";

import { UserInfo } from "src/common-items/models/user-info.model";
import { HttpErrorResponse } from "@angular/common/http";
import { HelperService } from "src/common-items/services/helper.service";
import { LoaderService } from "../../../common-items/services/loader.service";
import { TranslateService } from "@ngx-translate/core";
import { PhoneVerificationStatuses } from "src/common-items/models/phone-verification-statuses.enum";

@Component({
  selector: "cp-reset-password",
  templateUrl: "./bass-sca-reset-password.component.html",
  styleUrls: ["./bass-sca-reset-password.component.less"],
})
export class BassScaResetPasswordComponent implements OnInit {
  counter: number = 0;
  interval: any = null;
  Math: any;
  errorMessage: string = "";
  token: string = "";
  showBigLoader: boolean = false;
  isValidToken: boolean = true;
  showVerifyBox: boolean = false;
  errorMessages = ErrorMessages;
  userInfo: any = {};
  showPasswordPage: boolean = false;
  showSucessPage: boolean = false;
  otpExpireFlag: boolean = false;
  isResendBtn: boolean = true;
  isTimeOutHappened: boolean = false;
  isOtpSuccess: boolean = false;
  authData: any;
  authType: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private resetPwdService: BassScaResetPasswordService,
    private helperService: HelperService,
    public loaderService: LoaderService
  ) {}

  ngOnInit() {
    // validate the token
    this.route.paramMap.subscribe((params) => {
      this.token = params.get("token");
    });

    sessionStorage.setItem("_RES_PWD_TOKEN", JSON.stringify(this.token));
    this.verifyToken();
  }

  verifyToken() {
    this.showBigLoader = true;
    this.resetPwdService.verifyToken().subscribe(
      (res) => {
        if (res?.mobileNumber) {
          this.showBigLoader = false;
          this.userInfo.userMobile = res.mobileNumber;
          this.helperService.redirectUrl = res.redirectUrl;
        }
      },
      (error: any) => {
        this.loaderService.hide();
        this.showBigLoader = false;
        this.helperService.redirectUrl = error.redirectUrl;
        this.errorMessage = this.helperService.checkErrorMessage(error?.errorCode ? error.errorCode : 'WENT_WRONG')
      }
    );
  }

  onFailedResponse(errorCode: any) {
    this.loaderService.hide();
    this.showBigLoader = false;
    this.errorMessage = errorCode?.messages
      ? this.helperService.checkErrorMessage(errorCode.messages[0].code)
      : "";
  }

  sendOtp(isResnd) {
    let payload: any = {};
    if (isResnd) {
      payload.otpResend = true;
    }
    this.errorMessage = "";
    this.loaderService.show();
    this.resetPwdService.createOTP(payload).subscribe(
      (res: any) => {
        if (res.resendOtp === null) {
          let otpData = res;
          this.resetPwdService.otpReference = otpData.otpReference;
          this.showVerifyBox = true;
          this.startCountdown(otpData.sessionTime);
        } else if (res.resendOtp === true) {
          this.isResendBtn = false;
        }
        this.loaderService.hide();
      },
      (error: HttpErrorResponse) => this.onFailedResponse(error)
    );
  }

  resendOtp() {
    this.sendOtp(true);
  }

  startCountdown(seconds: any) {
    this.counter = 0;
    this.counter = seconds * 60;
    this.otpExpireFlag = false;

    this.interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
        clearInterval(this.interval);
        this.otpExpireFlag = true;
      }
    }, 1000);
  }

  phoneVerified(isVerified: boolean = true) {
    // Go to reset password page
    clearInterval(this.interval);
    this.showVerifyBox = false;
    this.showPasswordPage = true;
  }

  failedReceioveOtp() {
    clearInterval(this.interval);
  }

  onExpireToken(e) {
    if (e) {
      this.showPasswordPage = false;
      this.showVerifyBox = false;
      this.showSucessPage = true;
    } else {
      this.isValidToken = false;
    }
  }

  /**
   * This is the onSubmit function
   * @param No
   * @returns void
   */
  createOTP(isResnd: boolean = false): void {
    this.showBigLoader = true;
    let payload: any = {};
    if (isResnd) {
      payload.otpResend = true;
    }
    this.isTimeOutHappened = false;
    this.resetPwdService.createOTP(payload).subscribe(
      (res: any) => {
        if (res) {
          let otpData = res;
          this.authType = otpData.type;
          this.authType = otpData && otpData.type ? otpData.type : "OTP";

          if (this.authType === "DEVICE_AUTHORIZATION") {
            this.authData = {
              authType: "SCA",
              authCode: otpData.authCode,
              requestId: otpData.requestId,
              title: this.helperService.getCodeText(
                "CUSTOMER_OB.APPLICATION_PRICING.ENTER_RECEIVED_CODE_SCA"
              ),
              subTitle: this.helperService.getCodeText(
                "CUSTOMER_OB.APPLICATION_PRICING.SMS_CODE_SENT_SCA"
              ),
            };
          } else {
            this.authData = {
              authType: "OTP",
              authCode: otpData.authCode,
              requestId: otpData.requestId,
              title: this.helperService.getCodeText(
                "RESET_PASSWORD.TITLE_CNF_PASS"
              ),
              subTitle: this.helperService.getCodeText(
                "SMS code was sent to your mobile phone"
              ),
              mobileNo: this.userInfo.userMobile,
              sessionTime: otpData.sessionTime,
            };
          }
          this.isTimeOutHappened = false;
          this.showVerifyBox = true;
          this.showBigLoader = false;
        } else {
          this.showBigLoader = false;
          this.onFailedResponse(res.errorCode);
        }
      },
      (error: HttpErrorResponse) => {
        this.showBigLoader = false;
        this.onFailedResponse(error);
      }
    );
  }

  detectLocation() {
    this.showBigLoader = true;

    this.helperService.detectLocation().subscribe(
      (res: any) => {
        sessionStorage.setItem("IP_ADDRESS", res.IPv4);
        this.createOTP();
      },
      (error) => this.createOTP(true)
    );
  }

  authPopUpback() {
    this.showVerifyBox = false;
  }
  /* This is the verifyOtp function
   * @param No
   * @returns void
   */

  verifyOtp(otp: any): void {
    const codeInfo: any = {
      pin: otp,
    };
    this.showBigLoader = true;
    this.resetPwdService.verifyOtp(codeInfo).subscribe(
      (res) => {
        let response = res;
        this.showBigLoader = false;

        if (
          response &&
          response.otpStatus == PhoneVerificationStatuses.OTP_VERIFIED
        ) {
          this.isOtpSuccess = true;
          this.resetPwdService.userName = response.userName;
          this.phoneVerified();
        }
      },
      (err) => {
        // handle error here
        this.showBigLoader = false;
        if (
          err &&
          (err.messages[0].code == PhoneVerificationStatuses.OTP_FAILED_BASS ||
            err.messages[0].code == PhoneVerificationStatuses.OTP_EXPIRED_BASS)
        ) {
          this.loaderService.hide();
          this.isTimeOutHappened = true;
          return false;
        } else {
          this.onFailedResponse(err);
        }
      }
    );
  }
}
